import appApi from "@/app/api";
import { TBillingInterval } from "@/types/app";
import {
  CHECKOUT_SERVICE_BASE_URL,
  CHECKOUT_V2_ENDPOINTS,
} from "../constants.checkout";
import { CheckoutService } from "../service.checkout";
import { CheckoutProduct, TCheckoutType } from "../types.checkout";

export interface CheckoutExecutePayload {
  products: CheckoutProduct[];
  interval: TBillingInterval;
  discounts?: string[];
  use_referral_credits?: boolean;
  success_redirect_url?: string;
  failure_redirect_url?: string;
  country_code?: string;
}

export interface CheckoutExecuteSuccessData {
  status: true;
  data: string;
  error: undefined;
}

export interface CheckoutExecuteRedirectData {
  status: false;
  data: undefined;
  error: {
    code: 302;
    message: "checkout redirect";
    http_status_code: 302;
    data: {
      redirect_url: string;
    };
  };
}

export type CheckoutExecuteResponse =
  | CheckoutExecuteSuccessData
  | CheckoutExecuteRedirectData;

interface CheckoutOption {
  token: string;
  payload: CheckoutExecutePayload;
  checkoutType?: TCheckoutType;
}

export async function handlePaymentExecute(
  option: CheckoutOption,
): Promise<CheckoutExecuteResponse> {
  const headers = {
    Authorization: "Bearer " + option.token,
    "Content-Type": "application/json",
  };

  const apiUrl = option.checkoutType
    ? CHECKOUT_V2_ENDPOINTS[option.checkoutType].execute
    : `${CHECKOUT_SERVICE_BASE_URL}/purchase/execute`;

  try {
    const response = await appApi.post<CheckoutExecuteResponse>(
      apiUrl,
      option.payload,
      {
        headers,
      },
    );

    CheckoutService.logger.log("(checkout/execute)", {
      url: apiUrl,
      payload: option.payload,
    });

    const data = response?.data;

    return data;
  } catch (error: any) {
    if (
      error.response?.status === 302 ||
      error.response?.data?.error?.code === 302
    ) {
      return error.response.data as CheckoutExecuteRedirectData;
    }

    CheckoutService.logger.log("Error executing checkout:", error);
    throw error;
  }
}
